import { getMunData } from "utils";
const data = getMunData();

const commonEnglish = {
  header: "Infrastructure Management System",
  headerDistrict: `${data.municipality_title_en}`,
  total_projects: "TOTAL PROJECTS",
  worth_of_projects: "WORTH OF PROJECTS",
  running: "Running",
  not_started: "Not Started",
  incomplete: "Incomplete",
  tendered: "Tendered",
  pipeline: "Approved",
  implementation: "Started",
  implemented: "Started",
  cancelled: "Cancelled",
  completed: "Completed",
  completion: "Completed",
  dataNotAvailable: "Sorry we could not find any data!",
  ward: "WARD",
  wards: "WARDS",
  status: "STATUS",
  progressBarTitle: "BUDGET VS. EXPENDITURE",
  budget: "Budget",
  expenditure: "Expenditure",
  circularProgressBarTitle: "OVERALL PROJECT PROGRESS",
  physical: "Physical",
  financial: "Financial",
  physicalProgress: "Physical Progress",
  financialProgress: "Financial Progress",
  progress: "Progress",
  stats: "Stats",
  nrs: "NRs.",
  inNrs: "in NRs.",
  projects: "projects",
  project: "project",
  fiscalyear: "Fiscal Year",
  statsFor: "Stats for",
  allWards: "all wards",
  expectedBudget: "Expected Budget",
  submitted: "Submitted",
  evaluated: "Evaluated", 
  budgetFor: "Budget for", 
};

const commonNepali = {
  header: "पूर्वाधार व्यवस्थापन प्रणाली",
  headerDistrict: `${data.municipality_title}`,
  total_projects: "कुल परियोजनाहरु",
  worth_of_projects: "परियोजनाको लागत",
  running: "सञ्चालित",
  not_started: "सञ्चालनमा नआएकाे",
  incomplete: "अपूर्ण",
  tendered: "टेण्डर भएकाे",
  pipeline: "छनौट भएको",
  implementation: "सञ्चालित",
  implemented: "सञ्चालित",
  cancelled: "रद्द",
  completed: "पूरा भएको",
  completion: "पूरा भएको",
  dataNotAvailable: "माफ गर्नुहोस् हामी कुनै पनि डाटा फेला पार्न सकेनौँ!",
  ward: "वडा",
  wards: "वडाहरु",
  status: "अवस्था",
  progressBarTitle: "बजेट एवं खर्च",
  budget: "बजेट",
  expenditure: "खर्च",
  circularProgressBarTitle: "परियोजनाकाे समग्र प्रगति",
  physical: "भाैतिक",
  financial: "वित्तीय",
  physicalProgress: "भाैतिक प्रगति",
  financialProgress: "वित्तीय प्रगति",
  progress: "प्रगति",
  stats: "आँकडा",
  nrs: "नेरु",
  inNrs: "नेरु मा",
  projects: "परियोजनाहरू",
  project: "परियोजना",
  fiscalyear: "आर्थिक वर्ष",
  statsFor: "तथ्या्क",
  allWards: "सबै वडाको",
  expectedBudget: "अपेक्षित बजेट",
  submitted: "पेश गरिएको",
  evaluated: "मूल्याङ्कन गरिएको",
  budgetFor: "को लागि बजेट",
};

export { commonEnglish, commonNepali };



// WEBPACK FOOTER //
// ./src/localization/common.js